import * as React from "react";
/* empty css                                                                                                                      */
const PaymentMethodFormContainer = ({
  children,
  type,
  additionalOptions,
  checkout
}) => {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!checkout) {
      return;
    }
    const mountPayment = async () => {
      const c = await checkout;
      const paymentMethod = c?.create(type, additionalOptions);
      return paymentMethod?.mount(ref.current ?? "");
    };
    const promise = mountPayment();
    return () => {
      promise.then((component) => component?.unmount());
    };
  }, [type, additionalOptions, checkout]);
  if (!checkout) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { ref, className: "adyen-payment-method-form" }, children);
};
export {
  PaymentMethodFormContainer
};
//# sourceMappingURL=PaymentMethodFormContainer.js.map
